import {
  FETCH_ALL_PARTNERS,
  FETCH_PARTNER,
  CREATE_PARTNER,
  UPDATE_PARTNER,
  DELETE_PARTNER,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const partnersReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_PARTNERS}_PENDING`:
      return { ...state, message: null, loading: true };
    case `${FETCH_ALL_PARTNERS}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_PARTNERS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const partnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_PARTNER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_PARTNER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${FETCH_PARTNER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_PARTNER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_PARTNER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_PARTNER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updatePartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_PARTNER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_PARTNER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_PARTNER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deletePartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_PARTNER}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_PARTNER}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_PARTNER}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
